import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    EMPLOYEE_LIST,
    EMPLOYEE_DETAIL,
    EMPLOYEE_ADD,
    EMPLOYEE_UPDATE
} from '../actions';
import {
    EmployeeListSuccess,
    EmployeeListError,
    EmployeeDetailSuccess,
    EmployeeDetailError,
    EmployeeAddSuccess,
    EmployeeAddError,
    EmployeeUpdateSuccess,
    EmployeeUpdateError
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

// LIST
const onEmployeeListAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'employee/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onEmployeeList(action) {
    try {
        const response = yield call(onEmployeeListAsync, action.payload);
        yield put(EmployeeListSuccess(response.data));
    } catch (error) {
        yield put(EmployeeListError(error));
    }
}

// DETAIL
const onEmployeeDetailAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'employee/detail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onEmployeeDetail(action) {
    try {
        const response = yield call(onEmployeeDetailAsync, action.payload);
        yield put(EmployeeDetailSuccess(response.data.data));
    } catch (error) {
        yield put(EmployeeDetailError(error));
    }
}

// ADD
const onEmployeeAddAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'employee/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onEmployeeAdd(action) {
    try {
        const response = yield call(onEmployeeAddAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(EmployeeAddSuccess(response.data.id));
    } catch (error) {
        yield put(EmployeeAddError(error));
        NotificationManager.error('Error al agregar empleado', 'Error', 3000, null, null, '');
    }
}

// UPDATE
const onEmployeeUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'employee/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onEmployeeUpdate(action) {
    try {
        const response = yield call(onEmployeeUpdateAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(EmployeeUpdateSuccess(response.data));
    } catch (error) {
        yield put(EmployeeUpdateError(error));
        NotificationManager.error('Error al actualizar empleado', 'Error', 3000, null, null, '');
    }
}

function* watchEmployeeList() { yield takeEvery(EMPLOYEE_LIST, onEmployeeList); }
function* watchEmployeeDetail() { yield takeEvery(EMPLOYEE_DETAIL, onEmployeeDetail); }
function* watchEmployeeAdd() { yield takeEvery(EMPLOYEE_ADD, onEmployeeAdd); }
function* watchEmployeeUpdate() { yield takeEvery(EMPLOYEE_UPDATE, onEmployeeUpdate); }

export default function* rootSaga() {
    yield all([
        fork(watchEmployeeList),
        fork(watchEmployeeDetail),
        fork(watchEmployeeAdd),
        fork(watchEmployeeUpdate)
    ]);
}
